



































import Vue from 'vue'

export default Vue.extend({
  name: 'VirtualScrollerDemo',
  props: [],
  data() {
    return {
      basicItems:[],
      multiItems:[],
      tableItems:[],
      clos:[],
    }
  },
  watch: {
  },
  mounted(){
    this.basicItems = Array.from({ length: 100000 }).map((_, i) => `Item #${i}`);
    this.multiItems = Array.from({ length: 1000 }).map((_, i) => Array.from({ length: 1000 }).map((_j, j) => `Item #${i}_${j}`));
    this.tableItems = Array.from({ length: 100000  }).map((_, i) => ({
      a: `A #${i}`,
      b: `B #${i}`,
      c: `C #${i}`,
      d: `D #${i}`,
      e: `E #${i}`,
      f: `F #${i}`,
      g: `G #${i}`,
      h: `H #${i}`,
    }));
    this.clos = [
      {
        title: 'A',
        dataIndex: 'a',
        fixed: true,
        width: 150,
      },
      {
        title: 'B',
        dataIndex: 'b',
        width: 150,
      },
      {
        title: 'c',
        dataIndex: 'c',
        width: 150,
      },
      {
        title: 'd',
        dataIndex: 'd',
        width: 150,
      },
      {
        title: 'e',
        dataIndex: 'e',
        width: 150,
      },
      {
        title: 'f',
        dataIndex: 'f',
        width: 150,
      },
      {
        title: 'g',
        dataIndex: 'g',
        width: 150,
      },
      {
        title: 'h',
        dataIndex: 'h',
        width: 150,
      },
    ];

  },
  methods: {
  }
})
